import { DistributorMutation } from '@app/api/models/distributor';

import { DistributorFormInstance, SubChannelGuideRow } from '../types';

export const mapFormToMutation = (
  instance: Partial<DistributorFormInstance>,
  rawSubChannels: SubChannelGuideRow[]
): DistributorMutation => {
  const subId = Number(instance.sub_channel?.id);
  const row = rawSubChannels.find((r) => r.id === instance.sub_channel?.id);
  const channelId = Number(
    row?.channel_id ?? instance.channel?.id
  );

  const mutation: DistributorMutation = {
    _entityName: 'DistributorMutation',
    name: instance.name ?? '',
    inn: instance.inn ?? null,
    channel_id: channelId,
    sub_channel_id: subId,
    status_id: Number(instance.status?.id),
    tm: instance.tm ?? '',
    rm: instance.rm ?? '',
    legal_name: instance.legal_name ?? '',
    legal_address: instance.legal_address ?? '',
    description: instance.description ?? '',
    phone: instance.phone ?? '',
    email: instance.email ?? '',
    address: {
      address: instance.address?.address ?? '',
      city: instance.address?.city ?? null,
      region: instance.address?.region ?? null,
      ...(instance.address?.id != null ? { id: instance.address.id } : {}),
    },
    is_active: true,
  };
  if (instance.id != null) {
    mutation.id = instance.id;
  }
  return mutation;
};
